import moment from "moment"
import React, {FC} from "react"

import {FlexiPointsExpiry, PaymentCurrencyType} from "@irati/types"
import Flex from "@irati/ui/src/Flex"
import mainTheme from "@irati/ui/src/global/theme"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {Body} from "@irati/ui/src/Typography"
import {getNormalisedValue} from "@irati/utils/currency/formatCurrency"
import {FormattedMessage} from "@irati/utils/lang"

interface Props {
  id?: string,
  expiredFlexiPoints: FlexiPointsExpiry
}

const ExpiringSoonTooltipContent: FC<Props> = ({id, expiredFlexiPoints}) => (
  <Flex
    id={id}
    direction="column"
    padding={2}>
    <Body color={mainTheme.colors.filterChip} weight="semibold" marginBottom={1}>
      <FormattedMessage id="wallet.availableBalance.info.tooltip.title" />
    </Body>

    {/* limit the array to only render the first 3 elements. If there is less than 3, it will simply leave the array as it is */}
    {expiredFlexiPoints?.breakdown.slice(0, 3).map((element) => {
      const expiresAt = moment(element.expiresAt).format("DD/MM/YYYY")

      return <Flex>
        <Icon icon={IconTypes.flexiPoints} size={24} marginRight={0.5} />
        <Body small color={mainTheme.colors.filterChip}>
          <FormattedMessage
            id="wallet.availableBalance.info.tooltip.body"
            values={{amount: getNormalisedValue(true, PaymentCurrencyType.Tt, element.amount), expiresAt}} />
        </Body>
      </Flex>
    })}
  </Flex>
)

export default ExpiringSoonTooltipContent
